// export default {
//     test: 'http://localhost:3000',
//     product: 'https://eridu-app.herokuapp.com',
// }

// export default 'http://localhost:3000';
// export default 'https://eridu-app.herokuapp.com';
export default 'https://api.soibear.com';
